import React from 'react';
import {HealthParameterType} from '../../common/config';
import HealthComponent from '../health-component/health-component';

export default function BloodPressure() {
  return <HealthComponent type={HealthParameterType.BLOOD_PRESSURE} />;
}
